import { Heading, VStack, Text, HStack } from "@chakra-ui/react";
import { GridItem } from "@chakra-ui/react";

interface AirportSummaryProps {
  iata: string;
  name: string;
  city: string;
  country: string;
  emoji: string;
}

export const AirportSummary = ({
  iata,
  name,
  city,
  country,
  emoji,
}: AirportSummaryProps) => {
  return (
    <GridItem>
      <VStack align="center" textAlign="center">
        {/* Replace the separate emoji and IATA headings with an HStack for mobile */}
        <HStack display={{ base: "flex", md: "none" }}>
          <Heading color="white" fontSize="6xl" m={{ base: 0, md: 4 }}>
            {emoji}
          </Heading>
          <Heading color="white" fontSize="4xl" m={{ base: 0, md: 4 }}>
            {iata}
          </Heading>
        </HStack>
        {/* Show separate emoji and IATA headings for desktop */}
        <VStack display={{ base: "none", md: "flex" }}>
          <Heading color="white" fontSize="8xl" mt={10} mb={5}>
            {emoji}
          </Heading>
          <Heading
            color="white"
            fontSize={{ base: "6xl", lg: "8xl" }}
            mt={10}
            mb={{ base: 5, lg: 10 }}
          >
            {iata}
          </Heading>
        </VStack>

        <Heading
          color="white"
          fontSize={{ base: "md", lg: "2xl" }}
          lineHeight={{ base: "20px", lg: "30px" }}
          mt={{ base: 2, md: 0 }}
        >
          {name}
        </Heading>
        <Text
          color="white"
          fontFamily={"sans-serif"}
          fontSize={{ base: "sm", lg: "lg" }}
        >
          {city}, {country}
        </Text>
      </VStack>
    </GridItem>
  );
};
